import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileMergeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17 11c.002.552.448.998 1 1h9v16a2.006 2.006 0 0 1-2 2H7a2.006 2.006 0 0 1-2-2V4a2.006 2.006 0 0 1 2-2h10zM6.957 16.979v1.999h1a1 1 0 1 0 0-2zm4.246 0a1 1 0 1 0 0 1.999h1a1.003 1.003 0 0 0 1-1 1 1 0 0 0-1-1zm4.246 0a1 1 0 1 0 0 1.999h1a1.003 1.003 0 0 0 1-1 1 1 0 0 0-1-1zm4.246 0a1 1 0 1 0 0 1.999h1a1.003 1.003 0 0 0 1-1 1 1 0 0 0-1-1zm4.246 0a1 1 0 1 0 0 1.999h1v-2zM19 2.19a3.44 3.44 0 0 1 1.41.81l.3.29 5 5 .29.3c.379.398.656.882.81 1.41H19z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFileMergeFilledSVG);
ForwardRef.displayName = "IconFileMergeFilled";
export { ForwardRef as IconFileMergeFilled };
